import { NgModule } from '@angular/core';

import { OperationConfirmationModule } from './operation-confirmation/operation-confirmation.module';
import { OperationListModule } from './operation-list/operation-list.module';
import { OperationTransferenceModule } from './operation-transference/operation-transference.module';
import { OperationWithdrawalModule } from './operation-withdrawal/operation-withdrawal.module';

@NgModule({
  imports: [
    OperationConfirmationModule,
    OperationListModule,
    OperationTransferenceModule,
    OperationWithdrawalModule,
  ],
})
export class OperationModule {}
